import * as Yup from 'yup';
import { isYupStringSchema } from '../../../shared/utils/yup';
import { TemplateFormFieldValidation } from '../../interfaces/template-form';

export function MatchesValidation(
  validator: Yup.Schema<unknown>,
  validation: TemplateFormFieldValidation
) {
  const { value, errorMessage } = validation;

  if (value && isYupStringSchema(validator)) {
    return (validator as Yup.StringSchema).matches(new RegExp(value as string), {
      message: errorMessage,
      excludeEmptyString: true
    });
  }

  return validator;
}
